import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value: string | number;
  icon?: LucideIcon;
  color?: string;
  sub?: string;
  trend?: { value: number; positive?: boolean };
}

export function KpiCard({ label, value, icon: Icon, color = 'bg-brand-primary', sub, trend }: Props) {
  return (
    <div className="card p-5">
      {Icon && (
        <div className="flex items-start justify-between mb-3">
          <div className={cn('w-10 h-10 rounded-brand flex items-center justify-center', color)}>
            <Icon size={18} className="text-white" />
          </div>
          {trend && (
            <span
              className={cn(
                'text-xs font-medium',
                trend.positive === false ? 'text-red-600' : 'text-green-600',
              )}
            >
              {trend.positive === false ? '-' : '+'}
              {Math.abs(trend.value)}%
            </span>
          )}
        </div>
      )}
      <div className="text-2xl font-bold text-brand-dark font-heading">{value}</div>
      <div className="text-sm text-gray-500 mt-0.5">{label}</div>
      {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
    </div>
  );
}
